import React, { useEffect, useState } from "react"

import {
  Form,
  RadioButtonGroup,
  CheckboxInput,
} from "./Form"

import 'react-credit-cards/lib/styles'

import DeliveryDetails from "./DeliveryDetails";
import InvoiceEmail from "./InvoiceEmail";
import GuestOverrideName from "./GuestOverrideName";
import CreditCardPaymentForm from "./CreditCardPaymentForm";
import { validateCreditCardDetails } from '../utils/creditcard'
import FullScreenLoader from "./FullScreenLoader";

export default props => {
  const [paymentType, setPaymentType] = useState(Object.keys(props.order.paymentTypes)[0])
  const [submittingOrder, setSubmittingOrder] = useState(false)
  const [validCreditCard, setValidCreditCard] = useState(false)
  const [displayValidationErrors, setDisplayValidationErrors] = useState(false)
  const [displayAddress, setDisplayAddress] = useState((parseInt(props.selfPickUp)))
  const [creditCardNumber, setCreditCardNumber] = useState("")
  const [displayInvoiceEmail, setInvoiceEmail] = useState(props.order.orderType == 'pos')
  const [deliveryRequired, setDeliveryRequired] = useState(props.order.orderType != 'pos')
  const [processAndPrintRequested, setProcessAndPrintRequested] = useState(false)

  useEffect(() => {
    $(document).on("keydown", ":input:not(textarea)", function (event) {
      return event.key != "Enter";
    })
  }, [])

  const saveCreditCardPrefix = (creditCardNumber) => {
    const cleanedNumber = creditCardNumber.replace(/[\s-]/g, '');
    let paymentMethod = "OT"

    if (/^4[0-9]{12}(?:[0-9]{3})?$/.test(cleanedNumber)) {
      // Visa (VI)
      paymentMethod = "VI";
    } else if (/^5[1-5][0-9]{14}$/.test(cleanedNumber) || /^2(2[2-9][1-9]|[3-6][0-9]{2}|7[0-1][0-9]|720)[0-9]{12}$/.test(cleanedNumber)) {
      // MasterCard (MC)
      paymentMethod = "MC";
    } else if (/^3[47][0-9]{13}$/.test(cleanedNumber)) {
      // American Express (AE)
      paymentMethod = "AE";
    } else {
      // Other (OT)
      paymentMethod = "OT"
    }
    return fetch(`/orders/${props.order.id}.json`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content"),
      },
      body: JSON.stringify({ order: { payment_method: paymentMethod } })
    })
    .then(response => response.json())
    .then(response => {
      if (response.errors != null && response.errors.deleted_order_alert) {
        alert(response.errors.deleted_order_alert);
        window.open(`/`, '_self');
      }

      return response;
    })
  };

  const actionButtonTitle = () => {
    return Object.entries(props.order.paymentTypes).find(([key, value]) => key == paymentType)[1].shortName
  }

  const submitOrder = async e => {
    e.preventDefault()
    setDisplayValidationErrors(true)
    setSubmittingOrder(true)
    await saveCreditCardPrefix(creditCardNumber)

    props.handleOrderUpdate({ checkout: true, paymentType: paymentType }).then(response => {
      if (paymentType == 'credit_card' && !validCreditCard) {
        alert(`Please check your credit card information and try again.`)

        setSubmittingOrder(false);
        return;
      }

      if (Object.keys(response).length > 0 && Object.keys(response.order.errors).length > 0) {
        if (response.order.errors.foreign_country == 1) {
          alert(`If you require international delivery please e-mail the winery for assistance with your order.`)
        }
        if (response.order.errors.zero_quantity_selected != null) {
          alert(response.order.errors.zero_quantity_selected)
          window.location.reload();
        }


        alert(`Please choose pick up or delivery option and if choosing delivery please confirm your delivery address.`)
        setSubmittingOrder(false);
        return;
      }

      if (paymentType == 'credit_card') {
        document.getElementById('payment-form').submit();
      } else if (['invoice', 'cash'].includes(paymentType)) {
        window.location.reload();
      } else {
        window.open(`${props.orderPath}.pdf`, '_blank');
      }
    })
  }
  useEffect(() => {
    setDisplayAddress(parseInt(props.selfPickUp))
  }, [props.selfPickUp])


  return (
    <div className="edit_order">
      {submittingOrder && <FullScreenLoader />}
      <Form className="simple-form" id="order-form">

        {props.children}

        <hr />

        {!([1, 2].includes(displayAddress)) && (
          <DeliveryDetails
            order={props.order}
            countries={props.countries}
            handleOrderUpdate={props.handleOrderUpdate}
            onDeliveryRequiredChange={props.onDeliveryRequiredChange}
          />
        )}

        {displayInvoiceEmail && (
          <InvoiceEmail
            order={props.order}
          />
        )}

        {props.order.orderType == 'pos' && props.order.foodTableGuestOrder && (
          <GuestOverrideName
            order={props.order}
          />
        )}

        {props.order.orderType == 'pos' && (
          <CheckboxInput
            label=" Process order and print packing slip on payment"
            name="order[process_and_print_requested]"
            wrapperHTMLClassName="col-sm-12"
            checked={processAndPrintRequested}
            onChange={(e) => setProcessAndPrintRequested(e.target.checked)}
          />
        )}
      </Form>

      <h2 className="text-center">Payment</h2>
      <div className="payment">
        <div className="text-container">
          <p><strong>Payment Options:</strong></p>
          {Object.entries(props.order.paymentTypes).map(([key, value]) => <p key={key}>
            {value.description}
          </p>)}
        </div>

        <RadioButtonGroup
          name="payment_type"
          options={Object.entries(props.order.paymentTypes).map(([key, value]) => [value.longName, key])}
          wrapperHTMLClassName="order_payment_type"
          onChange={(e) => setPaymentType(e.target.value)}
          defaultChecked={paymentType}
        />
      </div>

      {paymentType == "credit_card" &&
        <CreditCardPaymentForm
          paymentGatewayData={props.order.paymentGatewayData}
          handleValidationChange={(valid) => setValidCreditCard(valid)}
          displayValidationErrors={displayValidationErrors}
          totalAmount={props.totalAmount}
          number={creditCardNumber}
          setNumber={setCreditCardNumber}
        />
      }

      <div className="form-actions">
        <button
          className="btn btn-primary btn-lg text-uppercase"
          name="commit"
          onClick={submitOrder}
          disabled={submittingOrder}
        >
          {submittingOrder ? 'Processing...' : actionButtonTitle()}
        </button>
      </div>
    </div>
  )
}
